//$FlowFixMe
import buttonLeft from 'app/tu-preferes-king/components/Button_carousel_left.webp'
//$FlowFixMe
import buttonRight from 'app/tu-preferes-king/components/Button_carousel_right.webp'
import React from 'react'
import type { CarouselRenderControl } from 'nuka-carousel'
import styled from 'styled-components'
import { media } from '../../../../assets/styles'

export const renderCenterLeftControls: CarouselRenderControl = ({
    previousSlide
}) => (
    <StyledButtonLeft
        onClick={previousSlide}
        src={buttonLeft}
        alt="Previous Slide"
    />
)

export const renderCenterRightControls: CarouselRenderControl = ({
    nextSlide
}) => (
    <StyledButtonRight onClick={nextSlide} src={buttonRight} alt="Next Slide" />
)

export const renderBottomCenterControls: CarouselRenderControl = ({
    previousSlide,
    nextSlide
}) => (
    <StyledBottomButtonGroup>
        <a
            href={'#'}
            onClick={ev => {
                ev.preventDefault()
                previousSlide()
            }}>
            <StyledButtonLeft
                onClick={previousSlide}
                src={buttonLeft}
                alt="Previous Slide"
            />
        </a>
        <a
            href={'#'}
            onClick={ev => {
                ev.preventDefault()
                nextSlide()
            }}>
            <StyledButtonRight
                onClick={nextSlide}
                src={buttonRight}
                alt="Next Slide"
            />
        </a>
    </StyledBottomButtonGroup>
)

const StyledButtonLeft = styled.img`
    transform: translateX(50%);
    cursor: pointer;
    width: 70%;
    ${media.medium`width: 100%;`}
`

const StyledButtonRight = styled.img`
    transform: translateX(-50%);
    cursor: pointer;
    width: 70%;
    ${media.medium`width: 100%;`}
`

const StyledBottomButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
    gap: 58px;
    ${media.medium`gap: 24px;`}
    transform: translateY(50px);
`
